import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

import {getToken,setToken,removeToken,setUserId} from '@/utils/auth'
import {login,urlLogin} from '@/api/login'
import {Message} from 'element-ui'
import JSONBig from "json-bigint";
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        tokenAuth: '',
        customerId: undefined,
        messageIp: '',
        customerObj: {}
    },
    mutations: {
        setToken(state,payload) {
            state.tokenAuth=payload
            setToken(payload)
        },
        setUserId(state,payload) {
            state.customerId=payload
            setUserId(payload)
        },
        setMessage(state,payload) {
            state.messageIp=payload
        },
        setCustomerObj(state,payload) {
            state.customerObj=payload
        }
        // removeToken(state){
        //   state.tokenAuth = undefined
        //   removeToken()
        // }
    },
    actions: {
        async login(context,data) {
            const res=await login(data)

            if(res.data.code!==200) {
                return Message.error("登录失败");
            } else {
                Message.success("登录成功")
                context.commit("setUserId",res.data.data.
                    id)
                context.commit("setCustomerObj",res.data.data)
                router.push('/home')
                if(res.data.tokenAuth) {
                    context.commit("setToken",res.data.tokenAuth)
                } else {
                    return res
                }
            }
        },
    },
     plugins: [
    createPersistedState({
      key: 'vuex',
      paths: ['customerObj'] 
    })
  ]
})